import { Helmet } from "react-helmet-async";

const SITE = "ACP Online";
const DEFAULT_DESC =
  "ACP Online — New Zealand trade supplier of IT, networking, POS, CCTV, audio-visual and office technology. Trade pricing, fast NZ delivery and GST tax invoices.";

export default function Seo({ title, description, image, type = "website", jsonLd, noindex = false, status404 = false, canonical }) {
  const full = title ? (title.includes(SITE) ? title : `${title} | ${SITE}`) : `${SITE} — New Zealand Trade Supplier`;
  const desc = (description || DEFAULT_DESC).slice(0, 300);
  const url = typeof window !== "undefined" ? window.location.href.split("#")[0] : "";
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canon = canonical ? (canonical.startsWith("http") ? canonical : origin + canonical) : url;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={noindex ? "noindex,follow" : "index,follow,max-image-preview:large"} />
      {status404 && <meta name="prerender-status-code" content="404" />}
      {canon && <link rel="canonical" href={canon} />}
      <meta property="og:site_name" content={SITE} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      {canon && <meta property="og:url" content={canon} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
